<template>
    <b-row>
        <Sidebar/>
        <b-col md="10" offset-md="2">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2">Casas: {{house.title}}</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <div class="btn-group mr-2">
                        <router-link class="btn btn-outline-secondary" to="/casas">{{cancelBtn.value}}</router-link>
                    </div>
                </div>
            </div>
            <p v-if="isLoading">Cargando...</p>
            <template v-else>
                <b-form v-on:submit.prevent="onSubmit">
                    <b-form-row>

                        <b-col md="4">
                            <b-form-group id="houseTitle" label="Casa:" label-for="houseTitleInput" description="">
                                <b-form-input v-model="house.house" id="houseTitleInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseLot" label="Lote:" label-for="houseLotInput" description="">
                                <v-select
                                        v-model="house.lot"
                                        :options="lots"
                                        placeholder="Selecciona un valor"
                                ><span slot="no-options">Valor no encontrado</span></v-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseAddress" label="Dirección:" label-for="houseAddressInput"
                                          description="">
                                <b-form-input v-model="house.address" id="houseAddressInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseClient" label="Cliente:" label-for="houseClientInput" description="">
                                <v-select
                                        v-model="house.client"
                                        :options="clients"
                                        placeholder="Selecciona un valor"
                                ><span slot="no-options">Valor no encontrado</span></v-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseStage" label="Etapa:" label-for="houseStageInput" description="">
                                <v-select
                                        v-model="house.stage"
                                        :options="stages"
                                        placeholder="Selecciona un valor"
                                ><span slot="no-options">Valor no encontrado</span></v-select>
                                <!--                                <b-form-input v-model="house.stage.name" id="houseStageInput" type="text"-->
                                <!--                                ></b-form-input>-->
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseStatus" label="Estado:" label-for="houseStatusInput" description="">
                                <v-select
                                        v-model="house.status"
                                        :options="status"
                                        placeholder="Selecciona un valor"
                                ><span slot="no-options">Valor no encontrado</span></v-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseDelivery" label="Entrega estimada:" label-for="houseDeliveryInput"
                                          description="">
                                <!--<b-form-input v-model="house.delivery_date" id="houseDeliveryInput" type="text"
                                ></b-form-input>-->
                                <datepicker
                                        :value="house.delivery_date"
                                        v-model="house.delivery_date"
                                        :format="niceDate"
                                        language="es"
                                        :bootstrap-styling="true"
                                        v-on:input="closeAlert"
                                ></datepicker>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="housePrice" label="Precio:" label-for="housePriceInput" description="">
                                <b-form-input v-model="house.price_uf" id="housePriceInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseBooking" label="Reserva:" label-for="houseBookingInput"
                                          description="">
                                <b-form-input v-model="house.booking_uf" id="houseBookingInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseDownPayment" label="Pie:" label-for="houseDownPaymentInput"
                                          description="">
                                <b-form-input v-model="house.downpayment_uf" id="houseDownPaymentInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseSitio" label="Sitio:" label-for="houseSitioInput" description="">
                                <b-form-input v-model="house.place" id="houseSitioInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseCondominio" label="Condominio:" label-for="houseCondominioInput"
                                          description="">
                                <b-form-input v-model="house.condo" id="houseCondominioInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseModelo" label="Modelo:" label-for="houseModeloInput" description="">
                                <b-form-input v-model="house.model" id="houseModeloInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseBathrooms" label="Baños:" label-for="houseBathroomsInput"
                                          description="">
                                <b-form-input v-model="house.bathrooms" id="houseBathroomsInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseBedrooms" label="Dormitorios:" label-for="houseBedroomsInput"
                                          description="">
                                <b-form-input v-model="house.bedrooms" id="houseBedroomsInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseSurface" label="Superficie:" label-for="houseSurfaceInput"
                                          description="">
                                <b-form-input v-model="house.surface_house" id="houseSurfaceInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group id="houseSurfaceTerrain" label="Superficie terreno:"
                                          label-for="houseSurfaceTerrainInput" description="">
                                <b-form-input v-model="house.surface_terrain" id="houseSurfaceTerrainInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-form-row>

                    <b-form-row>
                        <b-col md="12">

                            <div class="image__grid">
                                <div class="image__grid__item" v-for="(image, index) in house.images" :key="index">
                                    <span class="image__grid__close" @click="deleteImage(index)">X</span>
                                    <img :src="image.url" :alt="image.title">
                                </div>
                            </div>
                            <b-form-group id="lotImages" label="Imágenes:" label-for="lotImagesInput" description="">
                                <b-form-file
                                        id="lotImagesInput"
                                        v-model="images"
                                        v-on:input="onFileChange"
                                        :multiple="Boolean(true)"
                                        ref="imagesField"
                                        accept="image/jpeg"
                                        placeholder="Selecciona uno o mas imágenes..."
                                        drop-placeholder="Arrastra hasta aquí..."
                                ></b-form-file>
                            </b-form-group>

                        </b-col>
                    </b-form-row>

                    <b-form-row>
                        <b-col md="12">
                            <b-form-group id="houseVideo" label="Video:"
                                          label-for="houseVideoInput" description="">
                                <b-form-input v-model="house.video" id="houseVideoInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-form-row>


                    <b-form-row>
                        <b-col md="12">

                            <b-table hover v-bind:items="house.documents" v-bind:fields="documentHeaders"
                                     outlined
                                     head-variant="light">
                                <template slot="file" slot-scope="data">
                                    <b-link v-bind:to="data.item.file.url" target="_blank">{{data.item.file.name}}</b-link>
                                </template>
                                <template slot="title" slot-scope="data">
                                    <input type="text" v-model="data.item.title">
                                </template>
                                <template slot="actions" slot-scope="data">
                                    <div class="btn-group">
                                        <b-button variant="outline-secondary" size="sm" @click="deleteDocument(data.index)">Eliminar</b-button>
                                    </div>
                                </template>
                            </b-table>

                            <b-form-group id="houseDocuments" label="Documentos:" label-for="houseDocumentsInput"
                                          description="">
                                <b-form-file
                                        id="houseDocumentsInput"
                                        v-model="documents"
                                        v-on:input="onDocumentsChange"
                                        :multiple="Boolean(true)"
                                        ref="documentsField"
                                        placeholder="Selecciona uno o mas documentos..."
                                        drop-placeholder="Arrastra hasta aquí..."
                                ></b-form-file>
                            </b-form-group>

                        </b-col>
                    </b-form-row>

                    <b-button type="submit" variant="primary" v-bind:disabled="submitBtn.disabled">{{submitBtn.value}}
                    </b-button>
                </b-form>
                <hr>
            </template>
        </b-col>
    </b-row>
</template>

<script>
    import {mapGetters} from 'vuex'
    import vSelect from 'vue-select';
    import Datepicker from 'vuejs-datepicker';

    export default {
        name: "HousesAdd",
        components: {
            vSelect,
            Datepicker
        },
        data() {
            return {
                isLoading: true,
                images: [],
                documents: [],
                documentHeaders: [
                    {key: 'file', label: 'Archivo', sortable: false},
                    {key: 'title', label: 'Título', sortable: false},
                    {key: 'actions', label: 'Acciones', sortable: false},
                ],
                lotsList: [
                    {value: 'lot', label: 'Lote'},
                    {value: 'etapa', label: 'Etapa'}
                ],
                cancelBtn: {
                    value: "Cancelar"
                },
                submitBtn: {
                    disabled: false,
                    value: "Crear"
                },
                deleteBtn: {
                    disabled: false,
                    value: "Eliminar esta casa"
                }
            }
        },
        computed: {
            ...mapGetters({
                house: 'houses/getEntries',
                lots: 'lots/getSelectableEntries',
                stages: 'stages/getSelectableEntries',
                status: 'houses/getSelectableStatus',
                clients: 'users/getSelectableUsers',
                newImages: 'images/getImages',
                newDocuments: 'documents/getDocuments',
            })
        },
        methods: {
            onFileChange(files) {

                return this.$store.dispatch('images/loadImages', files).then(() => {
                    this.house.images = [...this.house.images, ...this.newImages];
                });

            },
            onDocumentsChange(files) {

                return this.$store.dispatch('documents/loadDocuments', files).then(() => {
                    this.house.documents = [...this.house.documents, ...this.newDocuments];
                });

            },
            deleteImage(index) {
                this.house.images.splice(index, 1);
            },
            deleteDocument(index) {
                this.house.documents.splice(index, 1);
            },
            onSubmit() {

                this.submitBtn.disabled = true;
                this.submitBtn.value = "Actualizando...";

                this.$store.dispatch('houses/updateEntry').then(() => {
                    this.submitBtn.value = "Casa actualizada";
                    this.cancelBtn.value = "Regresar";
                    setTimeout(() => {
                        this.submitBtn.disabled = false;
                    }, 3000);
                });

            },
            deleteLot() {
                return true;
            },
            niceDate(date) {
                return this.$moment(date).format('DD/MM/YYYY');
            },
            closeAlert() {
                return true;
            }
        },
        created() {
            this.isLoading = true;

            this.$store.dispatch('houses/setEntry', this.$route.params.id).then(() => {
                this.isLoading = false;
            });

            this.$store.dispatch('lots/loadEntries').then(() => {
                console.log('Lotes cargados.');
            });

            this.$store.dispatch('stages/loadEntries').then(() => {
                console.log('Etapas cargadas.');
            });

            this.$store.dispatch('users/loadUsers').then(() => {
                console.log('Clientes cargados.');
            });
        }
    }
</script>

<style scoped>
    .image__grid {
        border: 1px solid #dedede;
        background-color: #f7f7f7;
        margin-bottom: 10px;
        border-radius: 3px;
    }

    .image__grid__item {
        margin: 10px;
        display: inline-block;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
        position: relative;
        max-width: 20%;
        vertical-align: text-top;
    }

    .image__grid__item img {
        max-width: 100%;
        height: auto;
    }

    .image__grid__close {
        position: absolute;
        top: 0;
        right: 0;
        background: black;
        text-align: center;
        font-size: 16px;
        line-height: 16px;
        color: #fff;
        cursor: pointer;
        padding: 10px;
        opacity: .5;
        transition: opacity .3s ease-in-out;
    }

    .image__grid__close:hover {
        opacity: 1;
    }
</style>